import { Flags } from '@constants/flags';
import { WorkflowObjectTypes } from '@generated/graphql';
import { useFlag } from '@onevesthq/feature-flags/web';
import {
  resolveWorkflowCompletionUserId,
  type WorkflowCompletionIdentity,
} from '@utils/resolveWorkflowCompletionUserId';

type CompletionIdentityInput = Pick<
  WorkflowCompletionIdentity,
  'objectType' | 'objectId' | 'user'
>;

// `resolvesOwner` is false for flag off, untyped and HOUSEHOLD completions:
// callers keep passing objectId there (HOUSEHOLD steps still depend on the
// client group id, and hard-coded wizards build their completion on the
// client without an objectType). When true, `ownerId` is the resolved owner,
// or undefined for a completion without one: never fall back to objectId.
export const useWorkflowCompletionIdentity = ({
  objectType,
  objectId,
  user,
}: CompletionIdentityInput) => {
  const { enabled: contextAwareWorkflows } = useFlag(
    Flags.context_aware_workflows,
    { default: false },
  );
  const resolvesOwner =
    contextAwareWorkflows &&
    !!objectType &&
    objectType !== WorkflowObjectTypes.Household;

  return {
    resolvesOwner,
    ownerId: resolvesOwner
      ? resolveWorkflowCompletionUserId({ objectType, objectId, user })
      : undefined,
  };
};
